export default __webpack_public_path__ + "static/media/20_IMG_0113-min.7cbff557.jpg";